import React from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

const buttonDesign = {
  alignItems: "left",
  justifyContent: "flex-start",
  display: "flex",
  width: "fitContent",
  "&:focus": {
    outline: "none",
  },
};

const buttonTextDesign = {
  color: "#ffffff",
  fontFamily: "Inter",
  fontSize: "11px",
  fontWeight: "300",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textTransform: "none",
  opacity: "100%",
  justifyContent: "flex-start",
};

const falseButton = {
    ...buttonDesign,
    minWidth: '0px',
    "& span": {
      ...buttonTextDesign,
      color: "#ffffff",
      "&:hover": {
        opacity: "70%",
      },
    },
  }


const addButtonDesign = {
  width: "17px",
  height: "17px",
  border: "1px solid white",
  borderRadius: "5px",
  "WebkitTransform": "rotate(45deg)",
  "MozTransform": "rotate(45deg)",
  "OTransform": "rotate(45deg)",
  "msTransform": "rotate(45deg)",
  transform: "rotate(45deg)",
}


export const AddButton = (props) => {
  const {
    onClickHandler,
    disabled,
  } = props;

  return (
    <Button
      component="button"
      onClick={onClickHandler}
      sx={falseButton}
      key={`displayChartList-create`}
      disabled={disabled}
    >
    <Box component={"span"} sx={addButtonDesign}>×</Box>
  </Button>
  )
}

AddButton.propTypes = {
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
}